// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/styles/editor.scss
// module id = 5
// module chunks = 0